module.exports = __webpack_public_path__ + "static/banner-2-bg-fe15d0d63bc0a28ae8a163cc9e55111e.jpg";